import Home from './component-home'
import Contribution from './component-contribution'
import PageHeader from './component-header'

import Jesper1 from './jesper-01'
import Jesper2 from './jesper-02'
import Jesper3 from './jesper-03'
import Jesper4 from './jesper-04'
import Jesper5 from './jesper-05'
import Jesper6 from './jesper-06'

Vue.use(Router)

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual'
}

const router = new Router({
  //mode: 'history',
  routes: [
    {
      name: 'home',
      path: '/',
      component: Home
    },
    {
      name: 'jesper',
      path: '/jesper-olsson/',
      component: Contribution,
      props: {
        accentColor: '#cc5e1b'
      },
      children: [
        {
          name: 'jesper-1',
          path: '/jesper-olsson/part-1',
          component: Jesper1,
          props: {
            hello: 'world'
          }
        },
        { path: '/jesper-olsson/part-2', component: Jesper2 },
        { path: '/jesper-olsson/part-3', component: Jesper3 },
        { path: '/jesper-olsson/part-4', component: Jesper4 },
        { path: '/jesper-olsson/part-5', component: Jesper5 },
        { path: '/jesper-olsson/part-6', component: Jesper6 }
      ]
    }
  ],
  scrollBehavior: () => false
})

document.addEventListener('DOMContentLoaded', () => {

  new Vue({
    el: '#app',
    components: {
      PageHeader
    },
    data: {
      isHome: true
    },
    computed: {

    },
    methods: {
      scrollToTop() {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      },
      onTransitionLeave() {
        window.scrollTo(0, 0)
      }
    },
    mounted() {
      if (this.$router.currentRoute.name == 'home') {
        this.isHome = true
        router.app.$refs['header'].deactivate()

      } else {
        this.isHome = false
        router.app.$refs['header'].activate(true)
      }
    },
    router: router
  })

  router.beforeEach((to, from, next) => {

    const forceShowHeader = to.params.forceShowHeader

    // router.app.$refs['header'].deactivate()

    if (to.name == 'home') {
      router.app.isHome = true
      router.app.$refs['header'].deactivate()
    } else {
      router.app.isHome = false
      router.app.$refs['header'].activate(forceShowHeader)
    }

    next()

  })

})
